import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from "react";
import { KeyShortcut } from "~/components/AssetModal/Panel/Tabs/KeyboardShortcutsInfoButton/KeyboardShortcutsInfoModal/shared/KeyShortcut";
import { ShortcutInfo } from "~/components/ShortcutInfo";
import { formatShortcutKey } from "~/utils/KeyUtils";
export const ShortcutsList = (param)=>{
    let { shortcuts } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: shortcuts.map((shortcut)=>{
            return /*#__PURE__*/ _jsx(KeyShortcut, {
                icon: shortcut.icon,
                text: shortcut.label,
                children: shortcut.keys.map((key, index, array)=>{
                    const isCombination = key.includes("+") && key.split("+").length > 1;
                    const isLast = array[array.length - 1] === key;
                    if (isCombination) {
                        return /*#__PURE__*/ _jsx(Fragment, {
                            children: key.split("+").map((keyPart, index)=>{
                                return /*#__PURE__*/ _jsx(ShortcutInfo, {
                                    children: formatShortcutKey(keyPart)
                                }, index);
                            })
                        }, index);
                    }
                    return /*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(ShortcutInfo, {
                                children: formatShortcutKey(key)
                            }, key),
                            !isLast && /*#__PURE__*/ _jsx("span", {
                                className: "mx-0.5 text-12 text-pigeon-400",
                                children: shortcut.separator || "or"
                            })
                        ]
                    }, index);
                })
            }, shortcut.id);
        })
    });
};
